import { render, staticRenderFns } from "./PaginationSettings.vue?vue&type=template&id=6dc4da3e&"
import script from "./PaginationSettings.vue?vue&type=script&lang=ts&"
export * from "./PaginationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports